<app-menu></app-menu>

<section class="controlinventory-page" *ngIf="tenantId; else noAccess">
  <header class="page-header">
    <div class="page-guide">CONTROLPS / INVENTÁRIO</div>
  </header>

  <div class="tab-toolbar">
    <div class="cp-tabs inventory-main-tabs inventory-main-tabs--project-like">
      <button mat-stroked-button type="button" [class.active]="activeMainTab === 'dashboard'" (click)="setActiveMainTab('dashboard')">
        <mat-icon>dashboard</mat-icon>
        Dashboard
      </button>
      <button mat-stroked-button type="button" [class.active]="activeMainTab === 'assets'" (click)="setActiveMainTab('assets')">
        <mat-icon>inventory_2</mat-icon>
        Ativos
      </button>
      <button mat-stroked-button type="button" [class.active]="activeMainTab === 'kits'" (click)="setActiveMainTab('kits')">
        <mat-icon>workspaces</mat-icon>
        Kits
      </button>
    </div>
    <div class="tab-toolbar__actions">
      <button
        class="btn ghost"
        type="button"
        *ngIf="dashboardActiveFiltersCount > 0"
        (click)="resetDashboardFilters()">
        Limpar filtro
      </button>
      <button
        *ngIf="canManageCatalogs()"
        mat-stroked-button
        type="button"
        class="quick-actions-btn quick-actions-btn--secondary"
        (click)="openCatalogModal()">
        <mat-icon>tune</mat-icon>
        <span class="quick-actions-btn__label">CADASTROS</span>
      </button>
      <button mat-raised-button color="primary" class="quick-actions-btn" type="button" (click)="openAssetModal()">
        <mat-icon>add</mat-icon>
        <span class="quick-actions-btn__label">NOVO ATIVO</span>
      </button>
      <button class="filter-icon-button" type="button" (click)="openDashboardFilterModal()" aria-label="Filtrar inventário">
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  </div>

  <div class="page-headline">
    <h1>Inventário de ativos</h1>
    <p>Cadastro, status, kits, localizações e histórico dos itens da empresa.</p>
  </div>

  <section class="kpis" *ngIf="activeMainTab === 'dashboard'">
    <article class="kpi-card">
      <span>Em uso</span>
      <strong>{{ activeAssetsCount }}</strong>
      <small>Ativos em uso</small>
    </article>
    <article class="kpi-card">
      <span>Em estoque</span>
      <strong>{{ inactiveAssetsCount }}</strong>
      <small>Em estoque</small>
    </article>
    <article class="kpi-card">
      <span>Quebrados</span>
      <strong>{{ damagedAssetsCount }}</strong>
      <small>Itens quebrados</small>
    </article>
  </section>

  <section class="dashboard-section" *ngIf="activeMainTab === 'dashboard'">
    <header class="dashboard-section__head">
      <div>
        <h2>Movimentação e distribuição</h2>
        <p>Cadastros por mês e concentração por departamento.</p>
      </div>
    </header>
    <div class="dashboard-grid dashboard-grid--operations">
      <article class="panel panel--monthly">
        <header class="panel-head">
          <h3>Cadastro de ativos por mês</h3>
          <div class="dashboard-period-toggle">
            <button
              type="button"
              class="dashboard-period-btn"
              *ngFor="let option of dashboardPeriodOptions"
              [class.active]="dashboardPeriodMonths === option"
              (click)="setDashboardPeriod(option)">
              {{ option }}m
            </button>
          </div>
        </header>
        <div class="dashboard-line-chart" *ngIf="inventoryRegistrationsLineChartData.labels?.length; else noMonthlyData">
          <canvas
            baseChart
            [type]="'line'"
            [data]="inventoryRegistrationsLineChartData"
            [options]="dashboardLineChartOptions">
          </canvas>
        </div>
        <div class="dashboard-v2-legend">
          <span><i class="legend-dot legend-dot--primary"></i>Cadastros</span>
          <span><i class="legend-dot legend-dot--secondary"></i>Tendência</span>
          <span><i class="legend-line legend-line--average"></i>Média {{ monthlyAverageLabel }}/mês</span>
        </div>
      </article>

      <article class="panel panel--donut">
        <header class="panel-head">
          <h3>Distribuição por departamento</h3>
          <span>{{ departmentDonutTotal }} ativos</span>
        </header>
        <div class="department-donut" *ngIf="departmentDonutSegments.length; else noDepartmentDonutData">
          <div class="department-donut__chart" [style.background]="departmentDonutGradient">
            <div class="department-donut__center">
              <strong>{{ departmentDonutTotal }}</strong>
              <span>Ativos</span>
            </div>
          </div>
          <div class="department-donut__legend">
            <div class="department-donut__item" *ngFor="let row of departmentDonutSegments">
              <span class="department-donut__swatch" [style.background]="row.color"></span>
              <div>
                <strong>{{ row.label }}</strong>
                <small>{{ row.count }} · {{ row.percent }}%</small>
              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
  </section>

  <section class="dashboard-grid dashboard-grid--categories" *ngIf="activeMainTab === 'dashboard'">
    <article class="panel panel--wide">
      <header class="panel-head">
        <h3>Categorias cadastradas</h3>
        <span>{{ assetCategoryBars.length }} categorias</span>
      </header>
      <div class="category-bars" *ngIf="assetCategoryBars.length; else noCategoryBarsData">
        <div class="category-bars__summary">
          <div class="category-bars__metric">
            <strong>{{ dashboardTotalAssets }}</strong>
            <span>Itens no inventário</span>
          </div>
          <div class="category-bars__metric">
            <strong>{{ dashboardTopCategory }}</strong>
            <span>Categoria líder</span>
          </div>
        </div>
        <div class="bars category-bars__list">
          <div class="category-bar-row" *ngFor="let row of assetCategoryBars">
            <div class="bar-row__head">
              <span>{{ row.label }}</span>
              <strong>{{ row.count }} · {{ row.percent }}%</strong>
            </div>
            <div class="mini-bar">
              <div class="mini-bar__fill" [style.background]="row.color" [style.width.%]="row.percent"></div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </section>

  <section class="inventory-filter-bar" *ngIf="activeMainTab === 'assets'">
    <mat-form-field appearance="outline" class="digital-field modal-standard-field inventory-filter-field inventory-filter-field--search">
      <mat-label>Pesquisar por nome, lacre ou local</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput type="search" [(ngModel)]="assetSearch" name="asset_search" (ngModelChange)="onAssetFilterChange()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="digital-field modal-standard-field inventory-filter-field">
      <mat-label>Tipo</mat-label>
      <mat-select [(ngModel)]="assetTypeFilter" name="asset_type" (selectionChange)="onAssetFilterChange(false)">
        <mat-option value="ALL">Todos</mat-option>
        <mat-option *ngFor="let type of assetTypes" [value]="type">{{ assetTypeLabel(type) }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="digital-field modal-standard-field inventory-filter-field">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="assetStatusFilter" name="asset_status" (selectionChange)="onAssetFilterChange(false)">
        <mat-option *ngFor="let item of assetStatuses" [value]="item.value">{{ item.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="digital-field modal-standard-field inventory-filter-field">
      <mat-label>SKU exato</mat-label>
      <mat-icon matPrefix>confirmation_number</mat-icon>
      <input matInput type="search" [(ngModel)]="assetSkuFilter" name="asset_sku" placeholder="Digite o código completo" (ngModelChange)="onAssetFilterChange()">
    </mat-form-field>
  </section>

  <section class="inventory-list" *ngIf="activeMainTab === 'assets'">
    <article class="inventory-card" *ngFor="let asset of pagedAssets" (click)="openAssetModal(asset)">
      <div class="inventory-card__thumb">
        <ng-container *ngIf="asset.has_photo; else assetThumbPlaceholder">
          <img [src]="assetPhotoUrl(asset)" [alt]="asset.name" loading="lazy">
        </ng-container>
        <ng-template #assetThumbPlaceholder>
          <mat-icon>image_not_supported</mat-icon>
        </ng-template>
      </div>
      <div class="inventory-card__content">
        <div class="inventory-card__main">
          <div>
            <strong>{{ asset.name }}</strong>
            <small>{{ assetTypeLabel(asset.type) }} · {{ asset.sku || 'SKU não informado' }}</small>
          </div>
          <div class="inventory-card__actions inventory-card__actions--compact">
            <span class="status-pill" [class.stock]="isAssetInStock(asset.status)">{{ assetStatusLabel(asset.status) }}</span>
            <button class="icon-button" type="button" (click)="openAssetModal(asset); $event.stopPropagation()">
              <mat-icon>edit</mat-icon>
            </button>
            <button class="icon-button danger" type="button" (click)="deactivateAsset(asset, $event)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
        <div class="inventory-card__meta">
          <span>Categoria: {{ asset.category || '—' }}</span>
          <span>Marca: {{ asset.brand || '—' }}</span>
          <span>Local: {{ asset.location_name || '—' }}</span>
          <span>Natureza: {{ assetNatureLabel(asset.asset_nature) }}</span>
          <span *ngIf="asset.hosting_provider">Hospedagem: {{ asset.hosting_provider }}</span>
          <span *ngIf="asset.asset_nature === 'VIRTUAL'">
            Reserva: {{ asset.has_reservation ? ('Sim, até ' + formatDate(asset.reservation_end_date)) : 'Não' }}
          </span>
          <span>Setor/Departamento: {{ assetDepartmentLabel(asset.department_id, asset.department_name, asset.sector_name) }}</span>
          <span>Kit: {{ asset.kit_name || '—' }}</span>
          <span>Entrada: {{ formatDate(asset.entry_date) }}</span>
          <span>Vinculado: {{ asset.linked_user_names || 'Não' }}</span>
          <span>Criado por: {{ asset.created_by_name || asset.created_by || '—' }}</span>
        </div>
      </div>
    </article>
    <footer class="history-pagination" *ngIf="assetsTotal > assetPageSize">
      <button mat-stroked-button type="button" (click)="previousAssetPage()" [disabled]="assetPageIndex === 0">
        Anterior
      </button>
      <span>{{ assetPageStart }}-{{ assetPageEnd }} de {{ assetsTotal }}</span>
      <button mat-stroked-button type="button" (click)="nextAssetPage()" [disabled]="assetPageIndex >= assetPageCount - 1">
        Próxima
      </button>
    </footer>
    <p class="empty" *ngIf="loading">Carregando ativos...</p>
    <p class="empty" *ngIf="!loading && !assets.length">Nenhum ativo encontrado.</p>
  </section>

  <section class="inventory-list inventory-list--kits" *ngIf="activeMainTab === 'kits'">
    <div class="section-headline">
      <div>
        <h2>Kits</h2>
        <p>Agrupamentos de itens para instalação, filial ou ambiente.</p>
      </div>
      <button mat-raised-button color="primary" class="quick-actions-btn" type="button" (click)="openKitModal()">
        <mat-icon>add</mat-icon>
        <span class="quick-actions-btn__label">NOVO KIT</span>
      </button>
    </div>

    <article class="inventory-card inventory-card--kit" *ngFor="let kit of kits">
      <div class="inventory-card__main">
        <div>
          <strong>{{ kit.name }}</strong>
          <small>{{ kit.code || 'Sem código' }} · {{ kit.assets_count || 0 }} ativo(s)</small>
        </div>
        <div class="inventory-card__actions">
          <span class="status-pill" [class.inactive]="kit.status === 'INACTIVE'">{{ statusLabel(kit.status) }}</span>
          <button class="icon-button" type="button" (click)="openKitModal(kit)">
            <mat-icon>edit</mat-icon>
          </button>
          <button class="icon-button danger" type="button" (click)="deactivateKit(kit, $event)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <p class="inventory-card__desc">{{ kit.description || 'Sem descrição cadastrada.' }}</p>
    </article>
    <p class="empty" *ngIf="!kits.length">Nenhum kit cadastrado.</p>
  </section>

  <div class="modal-backdrop" *ngIf="showDashboardFilterModal" (click)="closeDashboardFilterModal()"></div>
  <aside class="side-modal filter-modal" *ngIf="showDashboardFilterModal" (click)="$event.stopPropagation()">
    <header>
      <div>
        <h2>Filtros</h2>
        <p>Refine {{ activeMainTab === 'assets' ? 'a lista de ativos' : 'o painel do inventário' }}.</p>
      </div>
      <button type="button" class="close" (click)="closeDashboardFilterModal()">&times;</button>
    </header>
    <div class="cp-modal__body">
      <h4 class="filter-section-title">Filtro inventário</h4>

      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Tipo</mat-label>
        <mat-select [(ngModel)]="dashboardFilters.type" [ngModelOptions]="{ standalone: true }" name="dashboard_type">
          <mat-option *ngFor="let option of dashboardTypeOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="dashboardFilters.status" [ngModelOptions]="{ standalone: true }" name="dashboard_status">
          <mat-option *ngFor="let option of dashboardStatusOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Categoria</mat-label>
        <mat-select [(ngModel)]="dashboardFilters.category" [ngModelOptions]="{ standalone: true }" name="dashboard_category">
          <mat-option *ngFor="let option of dashboardCategoryOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Local</mat-label>
        <mat-select [(ngModel)]="dashboardFilters.location" [ngModelOptions]="{ standalone: true }" name="dashboard_location">
          <mat-option *ngFor="let option of dashboardLocationOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Criado por</mat-label>
        <mat-select [(ngModel)]="dashboardFilters.created_by" [ngModelOptions]="{ standalone: true }" name="dashboard_created_by">
          <mat-option value="ALL">Todos os executores</mat-option>
          <mat-option *ngFor="let option of dashboardCreatorOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="digital-field modal-standard-field">
        <mat-label>Departamento</mat-label>
        <mat-select [(ngModel)]="dashboardFilters.department_id" [ngModelOptions]="{ standalone: true }" name="dashboard_department">
          <mat-option *ngFor="let option of dashboardDepartmentFilterOptions" [value]="option.value">{{ option.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="entry-footer">
      <button class="btn ghost" type="button" (click)="resetDashboardFilters()">Limpar</button>
      <button class="btn primary" type="button" (click)="applyDashboardFilters()">Aplicar filtros</button>
    </div>
  </aside>

  <div class="cp-modal-backdrop" *ngIf="showAssetModal" (click)="closeAssetModal()"></div>
  <section class="modal-card cp-modal-fixed-height inventory-modal" *ngIf="showAssetModal">
    <header class="modal-header">
      <div>
        <h2>{{ editingAssetId ? 'Editar ativo' : 'Novo ativo' }}</h2>
        <p class="modal-subtitle">Cadastro de item, localização, kit, detalhes e foto.</p>
      </div>
      <button class="icon-button" type="button" (click)="closeAssetModal()">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form class="cp-modal-body inventory-form" [formGroup]="assetForm">
      <div class="cp-tabs asset-modal-tabs">
        <button
          type="button"
          class="asset-modal-tab"
          [class.active]="assetModalTab === 'details'"
          (click)="setAssetModalTab('details')">
          Detalhes
        </button>
        <button
          type="button"
          class="asset-modal-tab"
          [class.active]="assetModalTab === 'link'"
          (click)="setAssetModalTab('link')">
          Vincular
        </button>
        <button
          type="button"
          class="asset-modal-tab"
          [class.active]="assetModalTab === 'history'"
          (click)="setAssetModalTab('history')">
          Histórico
        </button>
      </div>

      <div class="cp-modal-scroll">
        <ng-container [ngSwitch]="assetModalTab">
          <ng-container *ngSwitchCase="'details'">
            <section class="asset-details-view">
              <header class="asset-details-view__head">
                <div>
                  <h3>Detalhes do ativo</h3>
                  <p>Cadastro de item, localização, kit, detalhes e foto.</p>
                </div>
              </header>

              <div class="asset-form-top">
                <div
                  class="photo-dropzone photo-dropzone--first"
                  [class.active]="photoDragActive"
                  (click)="openPhotoPicker()"
                  (dragover)="onPhotoDragOver($event)"
                  (dragleave)="onPhotoDragLeave($event)"
                  (drop)="onPhotoDrop($event)">
                  <input #photoFileInput type="file" accept="image/*" hidden (change)="onPhotoSelected($event)">
                  <ng-container *ngIf="photoPreviewUrl; else photoPlaceholder">
                    <img class="photo-dropzone__preview" [src]="photoPreviewUrl" alt="Pré-visualização da foto do item">
                    <button class="photo-dropzone__remove" type="button" (click)="clearPhoto($event)">
                      <mat-icon>delete</mat-icon>
                      Remover foto
                    </button>
                  </ng-container>
                  <ng-template #photoPlaceholder>
                    <mat-icon>add_photo_alternate</mat-icon>
                    <strong>Foto do item</strong>
                    <span>Arraste uma imagem ou clique para selecionar.</span>
                  </ng-template>
                </div>

                <div class="asset-form-top__fields">
                  <div class="grid-2">
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>Nome</mat-label>
                      <input matInput formControlName="name">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>Tipo</mat-label>
                      <mat-select formControlName="type">
                        <mat-option *ngFor="let type of assetTypes" [value]="type">{{ assetTypeLabel(type) }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="grid-2">
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>SKU</mat-label>
                      <input matInput formControlName="sku" (input)="clearInventoryFieldError('sku')">
                      <mat-error *ngIf="assetForm.get('sku')?.hasError('duplicate')">SKU já cadastrado para este tenant.</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>Data de entrada</mat-label>
                      <input matInput formControlName="entry_date" type="date">
                    </mat-form-field>
                  </div>

                  <div class="grid-2">
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>Categoria</mat-label>
                      <mat-select formControlName="category" (selectionChange)="onAssetCategoryChange()">
                        <mat-option value="">Selecione</mat-option>
                        <mat-option *ngFor="let category of assetCategories" [value]="category">{{ category }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>Subcategoria</mat-label>
                      <mat-select formControlName="subcategory" [disabled]="!assetForm.get('category')?.value">
                        <mat-option value="">Selecione</mat-option>
                        <mat-option *ngFor="let subcategory of assetSubcategories" [value]="subcategory">{{ subcategory }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="grid-2">
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>Setor / Departamento</mat-label>
                      <mat-select formControlName="department_id" (selectionChange)="onAssetDepartmentChange()">
                        <mat-option [value]="null">Selecione</mat-option>
                        <mat-option *ngFor="let department of assetDepartmentOptions" [value]="department.id">
                          {{ department.sector_name ? department.sector_name + ' / ' : '' }}{{ department.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div></div>
                  </div>
                </div>
              </div>

              <div class="grid-2">
                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>Marca</mat-label>
                  <mat-select formControlName="brand">
                    <mat-option value="">Selecione</mat-option>
                    <mat-option *ngFor="let brand of assetBrands" [value]="brand">{{ brand }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>Lacre do item</mat-label>
                  <input matInput formControlName="seal_item" (input)="clearInventoryFieldError('seal_item')">
                  <mat-error *ngIf="assetForm.get('seal_item')?.hasError('duplicate')">Lacre já cadastrado para este tenant.</mat-error>
                </mat-form-field>
              </div>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Status</mat-label>
                <mat-select formControlName="status">
                  <mat-option *ngFor="let option of assetFormStatusOptions" [value]="option.value">{{ option.label }}</mat-option>
                </mat-select>
              </mat-form-field>

              <div class="grid-2">
                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>Local</mat-label>
                  <mat-select formControlName="location_name">
                    <mat-option value="">Selecione</mat-option>
                    <mat-option *ngFor="let location of assetLocations" [value]="location">
                      {{ location }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>Kit</mat-label>
                  <mat-select formControlName="kit_id">
                    <mat-option [value]="null">Nenhum</mat-option>
                    <mat-option *ngFor="let kit of kits" [value]="kit.id">{{ kit.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Endereço</mat-label>
                <input matInput formControlName="address">
              </mat-form-field>

              <section class="infrastructure-fields">
                <header>
                  <h4>Hospedagem e infraestrutura</h4>
                  <p>Classifique ativos físicos, virtuais e serviços hospedados.</p>
                </header>

                <div class="grid-2">
                  <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                    <mat-label>Natureza do ativo</mat-label>
                    <mat-select formControlName="asset_nature">
                      <mat-option value="">Não informado</mat-option>
                      <mat-option *ngFor="let option of assetNatureOptions" [value]="option.value">{{ option.label }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="showsHostedInfrastructureFields()">
                    <mat-label>Provedor / hospedagem</mat-label>
                    <input matInput formControlName="hosting_provider" [matAutocomplete]="providerOptions">
                    <mat-autocomplete #providerOptions="matAutocomplete">
                      <mat-option *ngFor="let provider of hostingProviderOptions" [value]="provider">{{ provider }}</mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>

                <ng-container *ngIf="showsHostedInfrastructureFields()">
                  <div class="grid-2">
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>Ambiente</mat-label>
                      <input matInput formControlName="environment_name" [matAutocomplete]="environmentOptionsList">
                      <mat-autocomplete #environmentOptionsList="matAutocomplete">
                        <mat-option *ngFor="let environment of environmentOptions" [value]="environment">{{ environment }}</mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>Hostname / IP</mat-label>
                      <input matInput formControlName="hostname_ip">
                    </mat-form-field>
                  </div>

                  <div class="grid-2">
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>Conta / assinatura / projeto</mat-label>
                      <input matInput formControlName="cloud_account">
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                      <mat-label>Região</mat-label>
                      <input matInput formControlName="cloud_region">
                    </mat-form-field>
                  </div>

                  <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                    <mat-label>Identificador externo / Resource ID</mat-label>
                    <input matInput formControlName="external_identifier">
                  </mat-form-field>
                </ng-container>

                <div class="grid-2" *ngIf="isVirtualAsset()">
                  <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                    <mat-label>Possui reserva?</mat-label>
                    <mat-select formControlName="has_reservation">
                      <mat-option [value]="false">Não</mat-option>
                      <mat-option [value]="true">Sim</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="digital-field modal-standard-field" *ngIf="assetForm.get('has_reservation')?.value === true">
                    <mat-label>Data final da reserva</mat-label>
                    <input matInput type="date" formControlName="reservation_end_date">
                    <mat-error *ngIf="assetForm.get('reservation_end_date')?.hasError('required')">
                      Informe quando a reserva termina.
                    </mat-error>
                  </mat-form-field>
                </div>
              </section>

              <div class="grid-2">
                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>Descrição</mat-label>
                  <textarea matInput rows="4" formControlName="description"></textarea>
                </mat-form-field>
                <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                  <mat-label>Detalhes</mat-label>
                  <textarea matInput rows="4" formControlName="details"></textarea>
                </mat-form-field>
              </div>

              <p class="inventory-form__error" *ngIf="assetSaveError">{{ assetSaveError }}</p>
            </section>
          </ng-container>

          <ng-container *ngSwitchCase="'link'">
            <section class="asset-link-view">
              <header class="asset-details-view__head">
                <div>
                  <h3>Vincular colaboradores</h3>
                  <p>Selecione os usuários que terão vínculo com este ativo.</p>
                </div>
              </header>

              <mat-form-field appearance="outline" class="digital-field modal-standard-field asset-link-view__search">
                <mat-label>Buscar usuário</mat-label>
                <mat-icon matPrefix>search</mat-icon>
                <input
                  matInput
                  type="search"
                  [(ngModel)]="assetUserSearch"
                  [ngModelOptions]="{ standalone: true }"
                  name="asset_user_search"
                  placeholder="Buscar usuário">
              </mat-form-field>

              <section class="asset-link-view__section" *ngIf="selectedAssetTenantUsers.length">
                <div class="asset-link-view__section-head">
                  <h3>Selecionados</h3>
                  <span>{{ selectedAssetTenantUsers.length }} colaborador(es)</span>
                </div>
                <article class="asset-link-card asset-link-card--selected" *ngFor="let user of selectedAssetTenantUsers; trackBy: trackByAssetUserId">
                  <div class="asset-link-card__content">
                    <strong>{{ user.name }}</strong>
                    <small>{{ user.email || 'Sem e-mail informado' }}</small>
                  </div>
                  <button class="asset-link-card__action asset-link-card__action--remove" type="button" (click)="toggleAssetUserSelection(user.id, false)">
                    <mat-icon>close</mat-icon>
                  </button>
                </article>
              </section>

              <section class="asset-link-view__section">
                <div class="asset-link-view__section-head">
                  <h3>Colaboradores</h3>
                  <span>{{ availableAssetTenantUsers.length }} disponíveis</span>
                </div>

                <div class="asset-link-view__loading" *ngIf="assetUsersLoading">Carregando colaboradores...</div>
                <ng-container *ngIf="!assetUsersLoading">
                  <article class="asset-link-card" *ngFor="let user of availableAssetTenantUsers; trackBy: trackByAssetUserId">
                    <div class="asset-link-card__content">
                      <strong>{{ user.name }}</strong>
                      <small>{{ user.email || 'Sem e-mail informado' }}</small>
                    </div>
                    <button class="asset-link-card__action" type="button" (click)="toggleAssetUserSelection(user.id, true)">
                      <mat-icon>add</mat-icon>
                    </button>
                  </article>
                  <div class="asset-link-view__empty" *ngIf="!availableAssetTenantUsers.length">
                    Nenhum colaborador encontrado.
                  </div>
                </ng-container>
              </section>

              <p class="inventory-form__error" *ngIf="assetSaveError">{{ assetSaveError }}</p>
            </section>
          </ng-container>

          <ng-container *ngSwitchCase="'history'">
            <div class="asset-history-view">
              <header class="asset-history-view__head">
                <div>
                  <h3>Histórico do ativo</h3>
                  <p>Movimentações, alterações e vínculos registrados para este item.</p>
                </div>
                <span class="asset-history-view__count">
                  {{ editingAssetId ? 'Item #' + editingAssetId : 'Novo ativo sem histórico' }}
                </span>
              </header>

              <div class="asset-history-view__body">
                <div class="empty" *ngIf="assetHistoryLoading">Carregando histórico...</div>
                <div class="asset-history-list asset-history-list--modal" *ngIf="!assetHistoryLoading">
                  <ng-container *ngIf="assetHistoryItems.length; else noHistory">
                    <article
                      class="history-item"
                      *ngFor="let item of assetHistoryItems; trackBy: trackByAssetHistoryId">
                      <div class="history-item__badge">
                        {{ assetHistoryActionLabel(item.action_type).charAt(0) }}
                      </div>
                      <div class="history-item__content">
                        <strong>{{ assetHistoryActionLabel(item.action_type) }}</strong>
                        <small>{{ formatHistoryTimestamp(item.created_at) }} · {{ item.created_by_name || item.created_by || '—' }}</small>
                        <small *ngIf="item.details">{{ item.details }}</small>
                      </div>
                    </article>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <footer class="modal-footer">
        <button mat-stroked-button type="button" (click)="closeAssetModal()">Cancelar</button>
        <button mat-raised-button color="primary" type="button" [disabled]="savingAsset || assetForm.invalid" (click)="saveAsset()">
          {{ savingAsset ? 'Salvando...' : 'Salvar ativo' }}
        </button>
      </footer>
    </form>
  </section>

  <div class="cp-modal-backdrop" *ngIf="showKitModal" (click)="closeKitModal()"></div>
  <section class="modal-card cp-modal-fixed-height inventory-modal" *ngIf="showKitModal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>{{ editingKitId ? 'Editar kit' : 'Novo kit' }}</h2>
        <p class="modal-subtitle">Agrupe ativos por instalação, filial ou projeto interno.</p>
      </div>
      <button class="icon-button" type="button" (click)="closeKitModal()">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <form class="cp-modal-body inventory-form" [formGroup]="kitForm">
      <div class="cp-modal-scroll">
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Nome do kit</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Código</mat-label>
          <input matInput formControlName="code">
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Descrição</mat-label>
          <textarea matInput rows="4" formControlName="description"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="digital-field modal-standard-field">
          <mat-label>Status</mat-label>
          <mat-select formControlName="status">
            <mat-option value="ACTIVE">Ativo</mat-option>
            <mat-option value="STOCK">Em estoque</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <footer class="modal-footer">
        <button mat-stroked-button type="button" (click)="closeKitModal()">Cancelar</button>
        <button mat-raised-button color="primary" type="button" [disabled]="savingKit || kitForm.invalid" (click)="saveKit()">
          {{ savingKit ? 'Salvando...' : 'Salvar kit' }}
        </button>
      </footer>
    </form>
  </section>

  <div class="cp-modal-backdrop" *ngIf="showCatalogModal" (click)="closeCatalogModal()"></div>
  <section class="modal-card cp-modal-fixed-height inventory-modal inventory-catalog-modal" *ngIf="showCatalogModal" (click)="$event.stopPropagation()">
    <header class="modal-header">
      <div>
        <h2>Cadastros do inventário</h2>
        <p class="modal-subtitle">Gerencie tipos, categorias, subcategorias, marcas e locais do tenant.</p>
      </div>
      <button class="icon-button" type="button" (click)="closeCatalogModal()">
        <mat-icon>close</mat-icon>
      </button>
    </header>
    <div class="cp-modal-body inventory-form">
      <div class="cp-modal-scroll">
        <div class="cp-tabs inventory-catalog-tabs">
          <button
            mat-stroked-button
            type="button"
            *ngFor="let tab of catalogTabs"
            [class.active]="selectedCatalogTab === tab.value"
            (click)="selectCatalogTab(tab.value)">
            <mat-icon>{{ tab.icon }}</mat-icon>
            {{ tab.label }}
          </button>
        </div>

        <div class="catalog-modal-grid">
          <article class="panel catalog-list-panel">
            <header class="panel-head">
              <h3>{{ catalogTabLabel(selectedCatalogTab) }}</h3>
              <span>{{ currentCatalogItems.length }} item(s)</span>
            </header>
            <div class="catalog-list">
              <article
                class="catalog-list__item"
                *ngFor="let item of currentCatalogItems"
                (click)="editCatalogItem(item)">
                <div class="catalog-list__content">
                  <strong>{{ item.name }}</strong>
                  <small>{{ catalogItemSubtitle(item) }}</small>
                </div>
                <div class="catalog-list__actions">
                  <span class="status-pill" [class.inactive]="item.status === 'INACTIVE'">{{ statusLabel(item.status) }}</span>
                  <button class="icon-button" type="button" (click)="editCatalogItem(item); $event.stopPropagation()">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button class="icon-button danger" type="button" (click)="deactivateCatalog(item, $event)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </article>
              <p class="empty" *ngIf="!currentCatalogItems.length">Nenhum item cadastrado para esta categoria.</p>
            </div>
          </article>

          <article class="panel catalog-form-panel">
            <header class="panel-head">
              <h3>{{ editingCatalogId ? 'Editar' : 'Novo' }} {{ catalogTabLabel(selectedCatalogTab) | lowercase }}</h3>
              <span>Tenant ativo</span>
            </header>
            <form class="catalog-form" [formGroup]="catalogForm">
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="name">
              </mat-form-field>
              <mat-form-field *ngIf="selectedCatalogTab === 'SUBCATEGORY'" appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Categoria pai</mat-label>
                <mat-select formControlName="parent_id">
                  <mat-option [value]="null">Selecione</mat-option>
                  <mat-option *ngFor="let category of catalogCategoryOptions" [value]="category.id">
                    {{ category.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="digital-field modal-standard-field">
                <mat-label>Status</mat-label>
                <mat-select formControlName="status">
                  <mat-option value="ACTIVE">Ativo</mat-option>
            <mat-option value="STOCK">Em estoque</mat-option>
                </mat-select>
              </mat-form-field>
              <div class="catalog-form__hint">
                O tipo atual é <strong>{{ catalogTabLabel(selectedCatalogTab) }}</strong>.
              </div>
              <p class="inventory-form__error" *ngIf="catalogSaveError">{{ catalogSaveError }}</p>
              <div class="catalog-form__actions">
                <button mat-stroked-button type="button" (click)="closeCatalogModal()">Cancelar</button>
                <button mat-raised-button color="primary" type="button" [disabled]="savingCatalog || catalogForm.invalid || (selectedCatalogTab === 'SUBCATEGORY' && !catalogForm.get('parent_id')?.value)" (click)="saveCatalogItem()">
                  {{ savingCatalog ? 'Salvando...' : 'Salvar cadastro' }}
                </button>
              </div>
            </form>
          </article>
        </div>
      </div>
    </div>
  </section>
</section>

<ng-template #noHistory>
  <div class="empty">Sem histórico registrado.</div>
</ng-template>

<ng-template #noMonthlyData>
  <div class="empty">Nenhum cadastro encontrado no período.</div>
</ng-template>

<ng-template #noDepartmentDonutData>
  <div class="empty">Nenhuma distribuição encontrada.</div>
</ng-template>

<ng-template #noCategoryBarsData>
  <div class="empty">Nenhuma categoria encontrada.</div>
</ng-template>

<ng-template #noAccess>
  <section class="no-access">
    <h2>Acesso restrito</h2>
    <p>Este módulo está disponível para tenants autorizados.</p>
  </section>
</ng-template>
